module.exports = __webpack_public_path__ + "07663611fd66fbf1ed9c118b00054e97.png";